import { renderSlot as _renderSlot, vShow as _vShow, withModifiers as _withModifiers, createVNode as _createVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7a6d6efb")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_white_backdrop = _resolveComponent("white-backdrop")

  return (_openBlock(), _createBlock(_Teleport, { to: "#floating" }, [
    _createVNode(_component_white_backdrop, {
      show: _ctx.show,
      onClick: _ctx.dismiss
    }, {
      default: _withId(() => [
        _withDirectives(_createVNode("div", {
          class: "floating",
          style: _ctx.pos,
          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
        }, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ], 4), [
          [_vShow, _ctx.show]
        ])
      ]),
      _: 3
    }, 8, ["show", "onClick"])
  ]))
})